// Product Page Notify Me Button Handler
(function() {
  'use strict';

  // Check if we're on the product page
  function isProductPage() {
    return window.location.pathname.includes('/products/') || 
           document.body.classList.contains('template-product') ||
           document.querySelector('[data-product-id]') !== null;
  }

  // Find notify me buttons (common selectors for notify me apps)
  function findNotifyMeButtons() {
    const selectors = [
      '[class*="notify"]',
      '[class*="restock"]',
      '[id*="notify"]',
      '[id*="restock"]',
      'button[data-notify]',
      'a[data-notify]',
      '.restock-alerts-button',
      '.notify-me-button',
      '[data-back-in-stock]'
    ];

    let buttons = [];
    selectors.forEach(selector => {
      try {
        const found = document.querySelectorAll(selector);
        if (found.length > 0) {
          buttons = buttons.concat(Array.from(found));
        }
      } catch (e) {
        // Invalid selector, skip
      }
    });

    // Filter to only actual buttons/clickable elements
    return buttons.filter(btn => {
      const tag = btn.tagName.toLowerCase();
      return (tag === 'button' || tag === 'a' || btn.onclick || btn.getAttribute('role') === 'button');
    });
  }

  // Create a custom notify me button
  function createNotifyMeButton() {
    const button = document.createElement('button');
    button.className = 'wishlist-notify-me-button';
    button.textContent = 'Size Unavailable? Notify Me';
    button.type = 'button';
    button.style.cssText = `
      background: #76222E;
      color: white;
      border: none;
      padding: 12px 24px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      margin-top: 15px;
      display: flex;
      align-items: center;
      width: 100%;
      max-width: 185px;
      transition: all 0.3s ease;
      display: none;
    `;

    // Add hover effect
    button.addEventListener('mouseenter', () => {
      button.style.backgroundColor = '#9a2d3d';
      button.style.transform = 'scale(1.05)';
    });
    button.addEventListener('mouseleave', () => {
      button.style.backgroundColor = '#76222E';
      button.style.transform = 'scale(1)';
    });

    return button;
  }

  // Find the wishlist button container on product page
  function findWishlistContainer() {
    const selectors = [
      '.wishlist-button',
      '#smartwishlist',
      '.smartwishlist',
      '.swbutton1',
      '.buy-buttons-block',
      '.product-form-buttons'
    ];

    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        return element;
      }
    }

    // Fallback: find the buy buttons block
    const buyButtonsBlock = document.querySelector('.buy-buttons-block');
    if (buyButtonsBlock) {
      return buyButtonsBlock;
    }

    return null;
  }

  // Handle button click - trigger the app's notify me button
  function handleNotifyMeClick(originalButtons) {
    if (originalButtons.length > 0) {
      // If app buttons exist, click the first one
      const firstButton = originalButtons[0];
      if (firstButton) {
        firstButton.click();
      }
    } else {
      // Fallback: try to find and trigger any notify me functionality
      const event = new Event('click', { bubbles: true });
      const notifyElements = document.querySelectorAll('[class*="notify"], [id*="notify"]');
      if (notifyElements.length > 0) {
        notifyElements[0].dispatchEvent(event);
      }
    }
  }

  // Main function to setup notify me button
  function setupNotifyMeButton() {
    if (!isProductPage()) {
      return;
    }

    // Wait for page to load and app buttons to render
    const checkInterval = setInterval(() => {
      const notifyButtons = findNotifyMeButtons();
      const wishlistContainer = findWishlistContainer();

      if (wishlistContainer) {
        clearInterval(checkInterval);

        // Check if notify me button already exists
        const existingButton = wishlistContainer.parentElement?.querySelector('.wishlist-notify-me-button') ||
                              document.querySelector('.wishlist-notify-me-button');
        if (existingButton) {
          return; // Already set up
        }

        // Create and add the button after wishlist container
        const notifyMeButton = createNotifyMeButton();
        
        // Add click handler
        notifyMeButton.addEventListener('click', (e) => {
          e.preventDefault();
          handleNotifyMeClick(notifyButtons);
        });

        // Insert after the wishlist container (at the bottom of wishlist area)
        if (wishlistContainer.parentElement) {
          wishlistContainer.parentElement.insertBefore(notifyMeButton, wishlistContainer.nextSibling);
        } else {
          wishlistContainer.appendChild(notifyMeButton);
        }

        // Also try to move existing app buttons to bottom if found
        if (notifyButtons.length > 0) {
          notifyButtons.forEach(btn => {
            // Only move if not already in the right place
            if (btn.parentElement !== wishlistContainer.parentElement) {
              if (wishlistContainer.parentElement) {
                wishlistContainer.parentElement.insertBefore(btn, notifyMeButton);
              }
            }
          });
        }
      }
    }, 500); // Check every 500ms

    // Stop checking after 10 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 10000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupNotifyMeButton);
  } else {
    setupNotifyMeButton();
  }

  // Also run on page navigation (for SPA-like navigation)
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      setTimeout(setupNotifyMeButton, 1000);
    }
  }).observe(document, { subtree: true, childList: true });
})();

